import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { isDefinedNotEmpty, LocalStorageService } from '@softline/core';
import { lastValueFrom } from 'rxjs';

export const terminalGuard: CanActivateFn = async (route, state) => {
  const service = inject(LocalStorageService);
  const router = inject(Router);
  try {
    const terminalRoute = await lastValueFrom(
      service.get<string>({ key: 'SoftAppsTerminal' })
    );
    console.log('terminalroute: ', terminalRoute);
    if (isDefinedNotEmpty(terminalRoute)) return router.parseUrl(terminalRoute);
  } catch (e) {
    console.log('terminalroute error: ', e);
    return true;
  }
  return true;
};
